export default __webpack_public_path__ + "static/media/Artwork_gmx.cc61d732.svg";